// components/MieterLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Layout from "./Layout";

export default function MieterLayout() {
  return (
    <PrivateRoute>
      <Layout>
        <Outlet />
      </Layout>
    </PrivateRoute>
  );
}
